/*
 * @Author: 陈乾
 * @Date: 2022-03-23 11:27:03
 * @LastEditors: 陈乾
 * @LastEditTime: 2022-05-17 21:07:03
 * @Description: file content
 */
const state = {
  // 登录信息
  userInfo: null
}

const mutations = {
  userInfo: (state, userInfo) => {
    state.userInfo = userInfo
  }
}

const actions = {
  commitUserInfo: ({ commit }, data) => {
    commit('userInfo', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
